/* eslint-disable*/

var checkGMATSubscription = function checkGMATSubscription(selectedLevel, exam_data) {
  console.log('Inside checkGMATSubscription partnerrrrr', selectedLevel, exam_data);
  var flag = false;
  for (var i = 0; i < exam_data.length; i++) {
    // if (exam_data[i].exam_name === selectedLevel) {
    //   // console.log('2');
    //   if (exam_data[i].levels.length) {
    //     // console.log('3');
    //     for (var j = 0; j < exam_data[i].levels.length; j++) {
    //       // console.log('4');
    //       if (exam_data[i].levels[j].partner) {
    //         /*
    //         ------------------
    //           Partner User's
    //         ------------------
    //         */
    //         // inside if block subscription check for partner users.
    //         if (exam_data[i].levels[j].isActive) {
    //           flag = true;
    //           break;
    //         }
    //       } else {
    //         /*
    //         ---------------
    //           App User's
    //         ---------------
    //         */
    //         // inside else block check for partner user app subsciption plans
    //         if (exam_data[i].levels[j].isActive) {
    //           flag = true;
    //           break;
    //         }
    //       }
    //     }
    //   } else {
    //     // console.log("6");
    //     flag = true;
    //   }
    //   break;
    // }
    // check subscription for partner users
    if (exam_data[i].exam_name === selectedLevel) {
      if (exam_data[i].levels.length) {
        // console.log('3');
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          // console.log('4');
          /*
            ------------------
              Partner User's
            ------------------
            */

          // inside if block subscription check for partner users.
          if (exam_data[i].levels[j].package_id === 43) {
            // SIMPLE package
            flag = false;
          }
          if (
            exam_data[i].levels[j].package_id === 44 ||
            exam_data[i].levels[j].package_id === 57
          ) {
            // EXPENSIVE package
            flag = true;
          }

          if (exam_data[i].levels[j].package_id === 45) {
            // LIFE-TIME package
            flag = true;
          }
        }
      } else {
        // console.log("6");
        flag = false;
      }
      break;
      // }
    }
  }
  return flag;
};

var checkGMATVideosSubscription = function checkGMATVideosSubscription(selectedLevel, exam_data) {
  var flag = false;
  for (var i = 0; i < exam_data.length; i++) {
    if (exam_data[i].exam_name === selectedLevel) {
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === 'expensive' &&
            exam_data[i].levels[j].isActive &&
            exam_data[i].levels[j].videoStatus !== false
          ) {
            flag = true;
            // break;
          } else if (
            exam_data[i].levels[j].package_val === 'simple' &&
            exam_data[i].levels[j].isActive &&
            exam_data[i].levels[j].videoStatus !== false
          ) {
            flag = true;
            // break;/
          } else if (
            exam_data[i].levels[j].package_val === 'unlimited' &&
            exam_data[i].levels[j].isActive
          ) {
            flag = true;
            // break;
          }
        }
      } else {
        flag = true;
      }
      // break;
    } else {
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === 'unlimited' &&
            exam_data[i].levels[j].package_id === 45
          ) {
            flag = true;
            break;
          }
        }
      }
    }
  }
  return flag;
};

var checkGMATQuestionSubscription = function checkGMATQuestionSubscription(
  selectedLevel,
  exam_data,
) {
  var flag = false;
  for (var i = 0; i < exam_data.length; i++) {
    // console.log("1");

    if (exam_data[i].exam_name === selectedLevel) {
      // console.log("2");
      if (exam_data[i].levels.length) {
        // console.log("3");
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === 'expensive' &&
            exam_data[i].levels[j].isActive
          ) {
            flag = true;
            break;
          } else if (
            exam_data[i].levels[j].package_val === 'simple' &&
            exam_data[i].levels[j].isActive &&
            exam_data[i].levels[j].noteStatus !== false
          ) {
            flag = true;
            break;
          } else if (
            exam_data[i].levels[j].package_val === 'unlimited' &&
            exam_data[i].levels[j].isActive
          ) {
            flag = true;
            break;
          }
        }
      } else {
        // console.log("6");
        flag = true;
      }
      // break;
    } else {
      // console.log("7");
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === 'unlimited' &&
            exam_data[i].levels[j].package_id === 45
          ) {
            flag = true;
            break;
          }
        }
      }
    }
  }

  return flag;
};

// this function check subscription only for quize
var checkGMATQuizSubscription = function checkGMATQuizSubscription(selectedLevel, exam_data) {
  console.log('Inside checkGMATSubscription partnerrrrr', selectedLevel, exam_data);
  var flag = false;
  for (var i = 0; i < exam_data.length; i++) {
    // check subscription for partner users
    if (exam_data[i].exam_name === selectedLevel) {
      if (exam_data[i].levels.length) {
        // console.log('3');
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          // console.log('4');
          /*
            ------------------
              Partner User's
            ------------------
            */

          // inside if block subscription check for partner users.
          if (exam_data[i].levels[j].package_id === 43) {
            // SIMPLE package
            flag = false;
          }
          if (exam_data[i].levels[j].package_id === 44) {
            // EXPENSIVE package
            flag = true;
          }

          if (exam_data[i].levels[j].package_id === 45) {
            // LIFE-TIME package
            flag = true;
          }
        }
      } else {
        // console.log("6");
        flag = false;
      }
      break;
      // }
    }
  }
  return flag;
};

exports.checkGMATSubscription = checkGMATSubscription;
exports.checkGMATQuestionSubscription = checkGMATQuestionSubscription;
exports.checkGMATVideosSubscription = checkGMATVideosSubscription;
exports.checkGMATQuizSubscription = checkGMATQuizSubscription;



// WEBPACK FOOTER //
// ./src/views/RestAPI/PartnerSubscription/GMATSubscription.js